window.__assetPrefix__ = 'https://d2iyg2dli5gr4t.cloudfront.net/vercel-frontend-centralized-auth';